import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setActive(null);
    if (active) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <div data-testid="gallery-page">
      <section className="pt-24 md:pt-32 pb-16 max-w-7xl mx-auto px-6 md:px-10">
        <div className="overline text-[color:var(--ek-accent)] mb-4">Galeri</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.95] max-w-3xl">
          Araç filosu, makine parkı, sınıflar.
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {items.map((it, i) => (
            <button
              key={it.id}
              onClick={() => setActive(it)}
              data-testid={`gallery-item-${i}`}
              className={`relative rounded-xl overflow-hidden bg-neutral-100 group ${
                i % 5 === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-square"
              }`}
            >
              <img
                src={it.url}
                alt={it.caption || "Galeri"}
                loading={i < 4 ? "eager" : "lazy"}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              {it.caption && (
                <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/70 to-transparent text-white text-xs md:text-sm text-left opacity-0 group-hover:opacity-100 transition-opacity">
                  {it.caption}
                </div>
              )}
            </button>
          ))}
        </div>
        {items.length === 0 && (
          <div className="py-24 text-center text-neutral-500">Henüz görsel yüklenmedi.</div>
        )}
      </section>

      {active && (
        <div
          className="fixed inset-0 z-50 lightbox-backdrop flex items-center justify-center p-4"
          onClick={() => setActive(null)}
          data-testid="lightbox"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-white/80 hover:text-white"
            data-testid="lightbox-close"
          >
            <X size={28} />
          </button>
          <img
            src={active.url}
            alt={active.caption || "Görsel"}
            className="max-w-full max-h-[90vh] rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
